import script from "./FlagComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./FlagComponent.vue?vue&type=script&lang=ts&setup=true"

import "./FlagComponent.vue?vue&type=style&index=0&id=e8fdac36&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e8fdac36"]])

export default __exports__